import {
  BooleanInput,
  Create,
  Datagrid,
  Edit,
  ImageField,
  List,
  NumberField,
  regex,
  required,
  SimpleForm,
  TextField,
  TextInput,
  UrlField,
  useRecordContext,
  useRefresh,
  useNotify,
  useRedirect,
} from "react-admin";

import { Star } from "lucide-react";
import { EditorToolbar, WideCard } from "../../components";

const validateImageLink = [
  required(),
  regex(
    /^(?:http(s)?:\/\/)[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/,
    "Must be a valid URL (http://...)",
  ),
];

const validateLink = regex(
  /^(?:http(s)?:\/\/)[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/,
  "Must be a valid URL (http://...)",
);

function ListView(props) {
  return (
    <List {...props} sort={{ field: "name", order: "ASC" }}>
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <NumberField source="id" />
        <ImageField source="image" sortable={false} />
        <TextField source="name" />
        <UrlField
          source="link"
          target="_blank"
          rel="noopener noreferrer"
          sortable={false}
        />
      </Datagrid>
    </List>
  );
}

const PreviewImage = (props) => {
  const record = useRecordContext();
  return (
    <a
      href={record.link}
      target="_blank"
      title={record.name}
      rel="noopener noreferrer"
    >
      <WideCard photo={record.image} containImage />
    </a>
  );
};

function renderEditForm() {
  return (
    <SimpleForm toolbar={<EditorToolbar />}>
      <TextInput source="name" fullWidth />
      <TextInput source="image" validate={validateImageLink} fullWidth />
      <TextInput source="link" validate={validateLink} fullWidth />
      <TextInput source="description" multiline fullWidth />
      <BooleanInput source="display_active" />
      <PreviewImage />
    </SimpleForm>
  );
}

function CreateView(props) {
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();
  return (
    <Create
      {...props}
      mutationMode="pessimistic"
      mutationOptions={{
        onSuccess: () => {
          notify("Partner created successfully!", {
            type: "success",
          });
          refresh(); // Ensures UI updates with the new data
          redirect("list", "partners");
        },
        onError: (error) => {
          notify(`Error: ${error.message}`, { type: "error" });
        },
      }}
    >
      {renderEditForm()}
    </Create>
  );
}

function EditView(props) {
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();
  return (
    <Edit
      {...props}
      mutationMode="pessimistic"
      mutationOptions={{
        onSuccess: () => {
          notify("Partner updated successfully!", {
            type: "success",
          });
          refresh(); // Ensures UI updates with the new data
          redirect(false);
        },
        onError: (error) => {
          notify(`Error: ${error.message}`, { type: "error" });
        },
      }}
    >
      {renderEditForm()}
    </Edit>
  );
}

export const Partners = {
  category: "tanext",
  name: "partners",
  create: CreateView,
  edit: EditView,
  icon: Star,
  list: ListView,
  options: { label: "Partners" },
};
